import React from 'react';
import { events, calendlyLink, images } from '../mock';
import { Calendar, MapPin, Clock } from 'lucide-react';

const EventsPage = () => {
  return (
    <div>
      {/* Header */}
      <section className="section-padding-small">
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Events
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px' }}>
            Join us for transformative experiences, healing circles, and community gatherings designed to support your journey of growth and awakening.
          </p>
        </div>
      </section>

      {/* Events List */}
      <section style={{ paddingBottom: '80px' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '32px'
          }}>
            {events.map((event) => (
              <div key={event.id} style={{
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                overflow: 'hidden'
              }} className="hover-lift">
                <img
                  src={event.image}
                  alt={event.title}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover'
                  }}
                />
                <div style={{ padding: '32px' }}>
                  {event.status === 'coming-soon' && (
                    <div style={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      background: 'var(--bg-primary)',
                      marginBottom: '16px',
                      fontSize: '12px',
                      fontWeight: 500
                    }}>
                      COMING SOON
                    </div>
                  )}
                  
                  <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                    {event.title}
                  </h2>
                  
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <Calendar size={16} style={{ color: 'var(--text-secondary)' }} />
                      <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                        {event.date}
                      </span>
                    </div>
                    {event.time !== 'TBA' && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <Clock size={16} style={{ color: 'var(--text-secondary)' }} />
                        <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                          {event.time}
                        </span>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <MapPin size={16} style={{ color: 'var(--text-secondary)' }} />
                      <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                        {event.location}
                      </span>
                    </div>
                  </div>

                  <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                    {event.description}
                  </p>

                  {event.status === 'recurring' && (
                    <div style={{
                      padding: '16px',
                      background: 'var(--bg-primary)',
                      borderRadius: '0px',
                      marginTop: '16px'
                    }}>
                      <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                        Join the WhatsApp group for weekly updates and exact meeting point:
                      </p>
                      <a 
                        href="https://chat.whatsapp.com/LXszXG0Gco2ErGLLpBwMxT"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: 'var(--interactive-base)',
                          textDecoration: 'underline',
                          fontSize: '13px',
                          fontWeight: 500
                        }}
                      >
                        Join WhatsApp Group
                      </a>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingTop: '16px',
                    borderTop: '1px solid var(--border-light)',
                    marginTop: '16px'
                  }}>
                    <span style={{
                      fontSize: '16px',
                      fontWeight: 500,
                      color: 'var(--text-primary)'
                    }}>
                      {event.price}
                    </span>
                    {event.status === 'coming-soon' && (
                      <button style={{
                        background: 'transparent',
                        color: 'var(--interactive-base)',
                        border: '1px solid var(--interactive-base)',
                        borderRadius: '0px',
                        padding: '12px 20px',
                        fontSize: '13px',
                        fontWeight: 500,
                        cursor: 'pointer'
                      }} className="btn-small">
                        Join Early Access List
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-1" style={{ marginBottom: '24px' }}>
            Interested in Private Sessions?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto 32px' }}>
            Book a one-on-one hypnotherapy session tailored specifically to your needs and goals.
          </p>
          <a
            href={calendlyLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: 'transparent',
              color: 'var(--interactive-base)',
              border: '1px solid var(--interactive-base)',
              borderRadius: '0px',
              padding: '19px 23px',
              minWidth: '210px',
              height: '60px',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="btn-primary"
          >
            Book A Service
          </a>
        </div>
      </section>

      <style>{`
        .btn-primary:hover,
        .btn-small:hover {
          background: var(--interactive-base);
          color: var(--bg-primary);
        }
      `}</style>
    </div>
  );
};

export default EventsPage;
